export function formatTime(d: Date | string | null | undefined): string {
  if (!d) return '—';
  return new Date(d).toLocaleTimeString('en-CA', { hour: '2-digit', minute: '2-digit' });
}

export function formatDate(d: Date | string | null | undefined): string {
  if (!d) return '—';
  return new Date(d).toLocaleDateString('en-CA', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' });
}